import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolumeOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M26.9997 0.333374C12.2723 0.333374 0.333008 12.2737 0.333008 27.003C0.333008 41.7322 12.2723 53.6726 26.9997 53.6726C41.7271 53.6726 53.6663 41.7322 53.6663 27.003C53.6663 12.2737 41.7271 0.333374 26.9997 0.333374Z",
			fill: "#212121"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1594 23.0874C17.5217 23.0874 17 23.6091 17 24.2468V30.0437C17 30.6814 17.5217 31.2031 18.1594 31.2031H21.081L25.394 36.5711C25.6142 36.8493 25.9505 37 26.2983 37C26.4258 37 26.5533 36.9768 26.6809 36.9305C27.1446 36.7682 27.4577 36.3276 27.4577 35.8406V31.6089L18.9362 23.0874H18.1594Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.42 34.0088C38.0316 32.177 39.0287 29.7654 39.0287 27.1336C39.0287 22.2874 35.6896 18.1832 31.1912 17.0354C30.4608 16.8499 29.7536 17.418 29.7536 18.1716C29.7536 18.6933 30.0898 19.1571 30.5999 19.2846C34.1129 20.1773 36.7099 23.354 36.7099 27.1452C36.7099 29.1394 35.9795 30.9596 34.7737 32.3741L33.139 30.7393C33.9158 29.7538 34.3911 28.5017 34.3911 27.1452C34.3911 25.012 33.2433 23.1453 31.5274 22.1367C30.739 21.6729 29.7536 22.2294 29.7536 23.1338C29.7536 23.5511 29.9739 23.9221 30.3333 24.1424C31.3651 24.7453 32.0723 25.8583 32.0723 27.1452C32.0723 27.8525 31.8405 28.5133 31.4695 29.0582L27.458 25.0467V18.4498C27.458 17.9629 27.145 17.5223 26.6812 17.36C26.2174 17.1977 25.7073 17.3484 25.3943 17.731L23.0523 20.6527L20.4553 18.0441C20.0031 17.5919 19.2727 17.5919 18.8206 18.0441C18.3684 18.4962 18.3684 19.2266 18.8206 19.6788L21.5915 22.4497L27.458 28.3162L29.8463 30.7045L31.3535 32.2117L33.0462 33.9044L34.7041 35.5624L35.5389 36.3971C35.7708 36.629 36.0606 36.7333 36.3621 36.7333C36.6635 36.7333 36.9534 36.6174 37.1852 36.3971C37.6374 35.945 37.6374 35.2145 37.1852 34.7624L36.42 33.9972V34.0088Z",
			fill: "white"
		})
	]
});
export default SvgVolumeOff;
